import axiosInstance from "../axiosClient";
import { addSubscription, subscriptionList } from "../config";


export const createSubscription =  async(data) => {
  return await axiosInstance.post(addSubscription,data);
};

export const getSubscription = async (name,limit,start_key) => {
    let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);
  
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return await axiosInstance.get(`${subscriptionList}${queryString}`);
};